export const avatarTokens = {
  avatar: {
    root: {
      borderRadius: '{borderRadius.full}'
    }
  }
};

export type AvatarTokens = typeof avatarTokens;
